import { consoleApiSlice } from "./consoleApiSlice";

export const consoleTeamUsageApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeamUsageOverview: builder.query({
      query: ({ startDate, endDate, env } = {}) => {
        const params = new URLSearchParams();
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        if (env) params.append("env", env);
        return { url: `/team-usage/overview?${params.toString()}`, method: "GET" };
      },
      providesTags: ["TeamUsage"],
    }),

    getBudgetConfig: builder.query({
      query: ({ env } = {}) => {
        const params = new URLSearchParams();
        if (env) params.append("env", env);
        return { url: `/budget-config?${params.toString()}`, method: "GET" };
      },
      providesTags: ["BudgetConfig"],
    }),

    updateBudgetConfig: builder.mutation({
      query: (body) => ({
        url: "/budget-config",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["BudgetConfig"],
    }),

    getAlertConfig: builder.query({
      query: ({ env } = {}) => {
        const params = new URLSearchParams();
        if (env) params.append("env", env);
        return { url: `/alert-config?${params.toString()}`, method: "GET" };
      },
      providesTags: ["AlertConfig"],
    }),

    updateAlertConfig: builder.mutation({
      query: (body) => ({
        url: "/alert-config",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["AlertConfig"],
    }),
  }),
});

export const {
  useGetTeamUsageOverviewQuery,
  useGetBudgetConfigQuery,
  useUpdateBudgetConfigMutation,
  useGetAlertConfigQuery,
  useUpdateAlertConfigMutation,
} = consoleTeamUsageApiSlice;
